"use strict";

exports.__esModule = true;
// Generated by CoffeeScript 1.12.6
var combineReducers;

exports.default = combineReducers = function (reducers, didDropKeys) {
  var finalReducers, k, v;
  finalReducers = {};
  for (k in reducers) {
    v = reducers[k];
    if (typeof v !== 'function') {
      throw new Error("Reducer for key `" + k + "` must be a function.");
    } else {
      finalReducers[k] = v;
    }
  }
  return function (state, action) {
    var hasChanged, key, nextState, nextStateForKey, previousStateForKey, reducer;
    if (state == null) {
      state = {};
    }
    hasChanged = false;
    nextState = {};
    for (key in finalReducers) {
      reducer = finalReducers[key];
      previousStateForKey = state[key];
      nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        throw new Error("Reducer for key `" + key + "` returned an undefined state.");
      }
      nextState[key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    if (!hasChanged && didDropKeys) {
      for (key in state) {
        if (!(key in finalReducers)) {
          hasChanged = true;
          break;
        }
      }
    }
    if (hasChanged) {
      return nextState;
    } else {
      return state;
    }
  };
};